import styled from "styled-components";

import { useFnrUploadButtonContext } from "../FnrUploadButton";
import { useExtendedOnChange } from "../stateHooks";

const SInput = styled.input`
  position: absolute;
  appearance: none;
  border: 0;
  clip: rect(0 0 0 0);
  width: 0;
  height: 0;
  opacity: 0;
  padding: 0;
  margin: 0;
`;

const InvisibleFileInput = () => {
  const { inputRef, readOnly } = useFnrUploadButtonContext();
  const extendedOnChange = useExtendedOnChange();

  return (
    <SInput
      aria-label="file-input"
      ref={inputRef}
      type="file"
      // this list of accepted files comes from BLL/utilities/UtilitiesHelper.php 
      accept=".jpg, .jpeg, .png, .gif, .doc, .docx, .ai, .eps, .mp3, .m4a, .pdf, .ppt, .pptx, .psd, .xls, .xlsx, .zip, .csv, .wmv, .ppts, .m4v"
      onChange={extendedOnChange}
      disabled={readOnly}
    />
  );
};

export default InvisibleFileInput;
